export default "__VITE_ASSET__B7YD6bFN__"